import { type FlyoutProps } from "../../utils/flyout-props";
import { useTriviaContext } from "./context-trivia";
import { TriviaContextProvider } from "./context-trivia-provider";
import { TriviaAnswer } from "./TriviaAnswer/TriviaAnswer";
import { TriviaContainer } from "./TriviaContainer/TriviaContainer";
import { TriviaQuestion } from "./TriviaQuestion/TriviaQuestion";
import { TriviaResult } from "./TriviaResult/TriviaResult";

function FlyoutTriviaContent() {
  const { component } = useTriviaContext();

  switch (component) {
    case "question":
      return (
        <TriviaContainer>
          <TriviaQuestion />
        </TriviaContainer>
      );
    case "answer":
      return (
        <TriviaContainer>
          <TriviaAnswer />
        </TriviaContainer>
      );
    case "result":
      return (
        <TriviaContainer>
          <TriviaResult />
        </TriviaContainer>
      );
    default:
      return null;
  }
}

export function FlyoutTrivia({ screen }: FlyoutProps) {
  return (
    <div className="relative h-full w-full">
      <TriviaContextProvider screen={screen}>
        <FlyoutTriviaContent />
      </TriviaContextProvider>
    </div>
  );
}
